import React from "react";
import { FaSpinner } from "react-icons/fa";
import { colors, typography, spacing } from "../utils/designTokens";

/**
 * Estado de carga unificado. Reemplaza los <FaSpinner/> + texto ad-hoc que
 * cada pantalla reinventaba con estilos distintos.
 *
 * Variantes:
 *  - inline: render compacto, una línea (default).
 *  - block: render centrado, ocupa el contenedor.
 *
 * Uso:
 *   <LoadingState message="Cargando edificios…" />
 *   <LoadingState variant="block" message="Cargando dashboard…" />
 */
export default function LoadingState({
  message = "Cargando…",
  variant = "inline",
  size = 14,
}) {
  if (variant === "block") {
    return (
      <div
        role="status"
        aria-live="polite"
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          gap: spacing[3],
          padding: spacing[6],
          minHeight: 160,
          color: colors.gray600,
        }}
      >
        <FaSpinner
          aria-hidden="true"
          size={size * 2}
          style={{
            animation: "spin 0.8s linear infinite",
            color: colors.primary,
          }}
        />
        <span style={{ fontSize: typography.sizes.sm, color: colors.gray700 }}>
          {message}
        </span>
      </div>
    );
  }
  return (
    <div
      role="status"
      aria-live="polite"
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: spacing[2],
        color: colors.gray600,
        fontSize: typography.sizes.sm,
      }}
    >
      <FaSpinner
        aria-hidden="true"
        size={size}
        style={{
          animation: "spin 0.8s linear infinite",
          color: colors.primary,
        }}
      />
      <span>{message}</span>
    </div>
  );
}
